import { useEffect } from 'react'
import { useGlobalContext } from '@/context/GlobalContext'

export const useHeader = () => {
  const { setHeaderText } = useGlobalContext()

  useEffect(() => {
    // Cleanup: reset header title when component unmounts

    return () => {
      setHeaderText('')
    }
  }, [setHeaderText])

  return {
    setHeaderText,
  }
}
